
import * as d3 from 'd3'
export default {
  methods: {

    draw_BlockList() {
      
      this.canvasStatus = this.svg
      .append('g')
      .attr('transform', `translate(${this.header.x+.5}, ${this.header.y + this.header.height+30.5})`)
      .attr('font-family', 'roboto').attr('cursor', 'default')

      



      let y_ = 0

      this.rawData.forEach((d,i)=> {

        this.gmx_Line(this.canvasStatus, 0, this.header.width, y_ + 117, y_ + 117, '#E0E0DF', .5, 1)

        this.draw_Structure(d, this.header.group[0], y_, i)
        this.draw_Outfitting(d, this.header.group[1], y_)
        this.draw_Outfitting(d, this.header.group[2], y_)
        this.draw_Outfitting(d, this.header.group[3], y_)
        this.draw_Outfitting(d, this.header.group[4], y_)
      

        y_ += 140
      })


    },

  }
}